import { render, staticRenderFns } from "./RecordSelect.vue?vue&type=template&id=20761ff6&scoped=true&"
import script from "./RecordSelect.vue?vue&type=script&lang=ts&"
export * from "./RecordSelect.vue?vue&type=script&lang=ts&"
import style0 from "./RecordSelect.vue?vue&type=style&index=0&id=20761ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20761ff6",
  null
  
)

export default component.exports